<nz-skeleton
  [ngClass]="loading ? 'mt-4' : 'mt-0'"
  [nzLoading]="loading"
  [nzActive]="true"
>
  <div class="mt-4">
    <span><b>Order Information</b></span>
    <div
      class="p-3 mt-2"
      style="border: 1px solid; border-color: grey; border-radius: 5px"
    >
      <div class="d-flex">
        <div class="">
          <p>No Order</p>
          <p>Date Order</p>
          <p>Payment Method</p>
          <p>Status</p>
        </div>
        <div class="ms-4">
          <p>: {{ detailOrder?.order_no || "-" }}</p>
          <p>
            :
            {{
              detailOrder?.formatted_date
                | date : "dd MMMM yyyy" : "id-ID"
            }}
          </p>
          <p>: {{ detailOrder?.payment_method || "-" }}</p>
          <span class="d-flex">
            :
            <p
              [ngClass]="handleClassStatus(detailOrder?.order_status || '')"
              class="ms-2"
            >
              {{ handleStatusOrder(detailOrder?.order_status || '') }}
            </p>
          </span>
        </div>
      </div>
    </div>
  </div>
</nz-skeleton>
